import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UpDown = function UpDown(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11.1891 6.1236C11.5883 5.57054 12.4117 5.57054 12.8109 6.12359L15.1861 9.41479C15.6634 10.0762 15.1908 11 14.3752 11H9.62478C8.80917 11 8.3366 10.0762 8.8139 9.41479L11.1891 6.1236Z",
      fill: color,
      fillOpacity: "0.4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.8109 17.8764C12.4117 18.4295 11.5883 18.4295 11.1891 17.8764L8.8139 14.5852C8.3366 13.9238 8.80917 13 9.62478 13L14.3752 13C15.1908 13 15.6634 13.9238 15.1861 14.5852L12.8109 17.8764Z",
      fill: color
    })]
  });
};
export default UpDown;